module.exports = __webpack_public_path__ + "static/media/tel.3b314582.jpg";